import CategoryService from './category.srv';
import multilevelCategorySelectionDirectiveFactory from './multilevel-category-selection/multilevel-category-selection.drv';
import categoryTitleFromIdFilterDirective from './category-title-from-id.flt';

angular.module('categories', ['common', 'core'])
	.service('categoryService', CategoryService)
	.directive('multilevelCategorySelection', multilevelCategorySelectionDirectiveFactory)
	.filter('categoryTitleFromId', categoryTitleFromIdFilterDirective);
